import React, { useContext } from 'react';

import { LicensesContext } from 'containers/pages/BillingLicenses/licensesContext';

const LicenseCounts = () => {
  const {
    licensesState: {
      editLicenseAssignment: {
        license_count,
        licenseCount,
        number_of_licenses_assigned,
        numberOfLicensesAssigned,
        number_of_licenses_available,
        numberOfLicensesAvailable,
      },
    },
  } = useContext(LicensesContext);

  return (
    <div className="m-edit-assignment__assignments">
      <div
        className="m-edit-assignment__assignment"
        data-testid="PlatformAdminUI-Licensing-LicenseCount-PurchasedText"
      >
        PURCHASED
        <div
          className="m-edit-assignment__value"
          data-testid="PlatformAdminUI-Licensing-LicenseCount-PurchasedCount"
        >
          {license_count || licenseCount}
        </div>
      </div>
      <div
        className="m-edit-assignment__assignment"
        data-testid="PlatformAdminUI-Licensing-LicenseCount-AssignedText"
      >
        ASSIGNED
        <div
          className="m-edit-assignment__value"
          data-testid="PlatformAdminUI-Licensing-LicenseCount-AssignedCount"
        >
          {number_of_licenses_assigned || numberOfLicensesAssigned}
        </div>
      </div>
      <div
        className="m-edit-assignment__assignment"
        data-testid="PlatformAdminUI-Licensing-LicenseCount-AvailableText"
      >
        AVAILABLE
        <div
          className="m-edit-assignment__value"
          data-testid="PlatformAdminUI-Licensing-LicenseCount-AvailableCount"
        >
          {number_of_licenses_available || numberOfLicensesAvailable}
        </div>
      </div>
    </div>
  );
};

export default LicenseCounts;
